import React, { Component } from 'react';
import { ajax, ViewModel } from '@platform/api';
const REFER_TEMPLET = 'REFER_TEMPLET';
const REFER_CONFIG = 'REFER_CONFIG';

export default function loadColumn(App) {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                referConfig: {},
                columns: [],
                pageid: '',
                ts: '',
            };
            this.firstFlag = false;
            this.loadConfig = true;
        }
        onBeforeFocus = async () => {
            if (this.firstFlag) {return;}
            this.firstFlag = true;
            let { dataval = '', refcode = '', pk_defdoclist = '' } = this.props;
            console.log(dataval, refcode);
            if (dataval || refcode) {
                let data = ViewModel.getData(
                    'REFER_TEMPLET' + dataval + refcode + pk_defdoclist,
                );
                if (data) {
                    let items = getItems(data.data);
                    let templet = data.data?.templet;
                    let pageid = templet?.pageid;
                    let ts = templet?.ts;
                    this.setState({ 
                        columns: items,
                        pageid,
                        ts,
                    });
                } else {
                    let params = {
                        refinfoid: dataval, //参照ID
                        refcode: refcode, //参照路径
                        pk_defdoclist,
                        compareTs: false, //是否比较ts
                        //ts: ''   // 模板的ts
                    };
                    //请求接口
                    let columnData = await columnAjax(params);
                    //记录下已经请求过了
                    ViewModel.setData('REFER_TEMPLET' + dataval + refcode + pk_defdoclist, { data: columnData });
                    if (columnData) {
                        let items = getItems(columnData);
                        let templet = columnData?.templet;
                        let pageid = templet?.pageid;
                        let ts = templet?.ts;
                        this.setState({
                            columns: items,
                            pageid,
                            ts,
                        });
                    }
                }
            }
            if (dataval) {
                let data = ViewModel.getData(
                    'REFER_CONFIG' + dataval + refcode,
                );
                if (data) {
                    this.setState({ referConfig: data.data });
                    this.loadConfig = false;
                } else {
                    let params = { refinfoid: dataval }; //参照ID
                    let configData = await configAjax(params);
                    ViewModel.setData('REFER_CONFIG' + dataval + refcode, { data: configData });
                    this.loadConfig = false;
                    if (configData) {
                        this.setState({ referConfig: configData });
                    }
                }
            } else {
                this.loadConfig = false;
            }
        };

        render() {
            let { columns, referConfig, pageid, ts } = this.state;
            return (
                <App
                    {...referConfig}
                    {...this.props}
                    loadColumns={columns}
                    pageid={pageid}
                    ts={ts}
                    loadConfig={this.loadConfig}
                    onBeforeFocus={this.onBeforeFocus}
                ></App>
            );
        }
    };
}

export function columnAjax(params) {
    return new Promise(resolve => {
        ajax({
            url: '/nccloud/platform/templet/queryRefInfoTemplet.do',
            data: params,
            loading: false,
            success: res => {
                if (res.success) {
                    let data = res.data;
                    console.log(
                        res,
                        'loadColumuloadColumuloadColumuloadColumu',
                    );
                    resolve(data);
                }
            },
            error: () => {
                resolve(false);
            },
        });
    });
}
export function configAjax(params) {
    return new Promise(resolve => {
        ajax({
            url: '/nccloud/lcdp/bdsetting/queryRefinfoFront.do',
            data: params,
            loading: false,
            success: res => {
                if (res.success) {
                    let data = res?.data?.refmeta;
                    console.log(res, 'queryRefinfoFrontqueryRefinfoFront');
                    resolve(data);
                }
            },
            error: () => {
                resolve(false);
            },
        });
    });
}
export function getItems(data) {
    let templet = data?.templet;
    let areacode = templet?.headcode;
    let items = [];
    if (templet && areacode) {
        items = templet[areacode].items || [];
    }
    return items;
}
